import xhrService from '../xhrService';
const baseUrl = `/api/maps`;

type MapApi = {
    directions: (params: any) => Promise<any>;
    getOptimizedRoute: (params: any) => Promise<any>;
    getProjectsMapsData: (params: any) => Promise<any>;
    getDashboardMapsFilterDropdownProject: (params: any) => Promise<any>;
    getDashboardMapsFilterDropdownInspector: (params: any) => Promise<any>;
};

const mapApi: MapApi = {
  directions: (params:any) => {
    return xhrService
      .get(`${baseUrl}/direction`, { params })
      .then((res) => res);
  },
  getOptimizedRoute: (params:any) => {
    return xhrService
      .get(`${baseUrl}/optimized-route`, { params })
      .then((res) => res);
  },
  getProjectsMapsData: (params:any) => {
    return xhrService
      .get(`${baseUrl}/get-projects-locations`, { params })
      .then((res) => res.data);
  },
  getDashboardMapsFilterDropdownProject: (params:any) => {
    return xhrService
      .get(`${baseUrl}/getDashboardMapsFilterDropdownProject`, { params })
      .then((res) => res.data);
  },
  getDashboardMapsFilterDropdownInspector: (params:any) => {
    return xhrService
      .get(`${baseUrl}/getDashboardMapsFilterDropdownInspector`, { params })
      .then((res) => res.data);
  }
};

export default mapApi;
